import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer, CardContent, Button, CircularProgress, Box,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import {useUpdateDataMutation, useUpdateScheduleMutation} from "../store/system/systemApi";
import User from "../_mock/user";
import {BallotOutlined, EventAvailable, GroupsOutlined, HistoryOutlined, Microwave, MoreTimeSharp, Schedule, TableChart} from "@mui/icons-material";
import ArticleIcon from "@mui/icons-material/Article";
import CheckIcon from "@mui/icons-material/Check";
import {useRestoreUnlinkedLessonsMutation} from "../store/journal/journalApi";
import {
    useAssignScheduleToVirtualGroupsMutation,
    useUpdateUnlinkedTeamsScheduleMutation
} from "../store/schedule/scheduleApi";
import SearchIcon from "@mui/icons-material/Search";
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';

export default function AdminPanelPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [dataUpdating, setDataUpdating] = useState(false);
    const [unlinkedLessonsRestoring, setUnlinkedLessonsRestoring] = useState(false);
    const data = null;
    const [updateData] = useUpdateDataMutation();
    const [updateSchedule] = useUpdateScheduleMutation();
    const [updateUnlinkedTeamsScheduleRequest] = useUpdateUnlinkedTeamsScheduleMutation();
    const [restoreUnlinkedLessonsRequest] = useRestoreUnlinkedLessonsMutation();
    const [assignScheduleToVirtualGroupsRequest] = useAssignScheduleToVirtualGroupsMutation();

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const handleUpdate = async (type) => {
        setDataUpdating(true);

        await updateData({data: {type}}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                alert('Готово')
            } else {
                fulfilled.errors.map((item) => {
                    alert(`Ошибка: ${item}`);
                    return 1;
                });
            }
        }).catch((ex) => {
            alert('Ошибка');
        }).finally(() => {
            setDataUpdating(false);
        });
    };
    
    function getUpdateButton(type, title) {
        return <li><Button onClick={() => handleUpdate(type)}
                    disabled={dataUpdating}>{title}</Button></li>
    }
    async function handleUnlinkedTeamsScheduleUpdate() {
        setDataUpdating(true);

        await updateUnlinkedTeamsScheduleRequest().unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                alert('Готово')
            } else {
                fulfilled.errors.map((item) => {
                    alert(`Ошибка: ${item}`);
                    return 1;
                });
            }
        }).catch((ex) => {
            alert('Ошибка');
        }).finally(() => {
            setDataUpdating(false);
        });
    }
    
    async function handleAssignScheduleToVirtualGroups() {
        setDataUpdating(true);

        await assignScheduleToVirtualGroupsRequest().unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                alert('Готово')
            } else {
                fulfilled.errors.map((item) => {
                    alert(`Ошибка: ${item}`);
                    return 1;
                });
            }
        }).catch((ex) => {
            alert('Ошибка');
        }).finally(() => {
            setDataUpdating(false);
        });
    }
    
    async function handleScheduleUpdate() {
        const week = prompt('Номер недели');
        if (!week) {
            return;
        }

        setDataUpdating(true);

        await updateSchedule({data: {weekNumber: week}}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                alert('Готово')
            } else {
                fulfilled.errors.map((item) => {
                    alert(`Ошибка: ${item}`);
                    return 1;
                });
            }
        }).catch((ex) => {
            alert('Ошибка');
        }).finally(() => {
            setDataUpdating(false);
        });
    }
    
    async function restoreUnlinkedLessons() {
        setUnlinkedLessonsRestoring(true);

        await restoreUnlinkedLessonsRequest().unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                alert('Готово')
            } else {
                fulfilled.errors.map((item) => {
                    alert(`Ошибка: ${item}`);
                    return 1;
                });
            }
        }).catch((ex) => {
            alert('Ошибка');
        }).finally(() => {
            setUnlinkedLessonsRestoring(false);
        });
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Админ-панель`}/>

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            Админ-панель
                        </Typography>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack spacing={2}>
                                <Typography variant={'h6'}>Обновление данных {dataUpdating ? <CircularProgress size={15}/> : <></>}</Typography>
                                <ol>
                                    {getUpdateButton('students', 'Студенты')}
                                    {getUpdateButton('employees', 'Преподаватели')}
                                    {getUpdateButton('all', 'Все данные (вкл. нагрузку) - может занять долгое время')}
                                    <li>
                                        <Button onClick={() => handleScheduleUpdate()}
                                                disabled={dataUpdating}>Расписание за неделю</Button>
                                    </li>
                                    <li>
                                        <Button onClick={() => handleUnlinkedTeamsScheduleUpdate()}
                                                disabled={dataUpdating}>Восстановить недостающие привязки подгрупп в расписании</Button>
                                    </li>
                                    <li>
                                        <Button onClick={() => handleAssignScheduleToVirtualGroups()}
                                                disabled={dataUpdating}>Привязать расписание к сводным группам</Button>
                                    </li>
                                </ol>
                                
                                <Typography fontSize={'x-small'}>* при обновлении всех данных настоятельно рекомендуется дождаться завершения операции</Typography>
                            </Stack>
                        </CardContent>
                    </Card>

                    <Card>
                        <CardContent>
                            <Stack spacing={2}>
                                <Typography variant={'h6'}>Управление системой</Typography>
                                <ol>
                                    <li><Button href={`/academic-year-readiness`} startIcon={<EventAvailable />}>Готовность к новому учебному году</Button></li>
                                    <li><Button href={`/user-flags`} startIcon={<BallotOutlined />}>Флаги-пользователей</Button></li>
                                    <li><Button href={`/edit-group-flows`} startIcon={<GroupsOutlined />}>Потоки</Button></li>
                                    <li><Button onClick={() => {restoreUnlinkedLessons();}} 
                                                startIcon={unlinkedLessonsRestoring ? <CircularProgress size={15} /> : <CheckIcon />}
                                                disabled={unlinkedLessonsRestoring}>
                                        Восстановить отвязанные от подгрупп занятия
                                        </Button>
                                    </li>
                                    <li><Button href={`/system-parameters`} startIcon={<Microwave />}>Системные параметры</Button></li>
                                    <li><Button href={`/assistant-history`} startIcon={<HistoryOutlined />}>История общения с ИИ-ассистентом</Button></li>
                                </ol>
                            </Stack>
                        </CardContent>
                    </Card>

                    <Card>
                        <CardContent>
                            <Stack spacing={2}>
                                <Typography variant={'h6'}>Вспомогательные инструменты</Typography>
                                <ol>
                                    <li><Button href={`/employee-schedule`} startIcon={<TableChart />}>Расписание преподавателя</Button></li>
                                    <li><Button href={`/employee-jobs-search`} startIcon={<SearchIcon />}>Поиск ставок преподавателя</Button></li>
                                    <li><Button href={`/chair-workloads`} startIcon={<TableChart />}>Просмотр учебной нагрузки в 1С</Button></li>
                                    <li><Button href={`/teacher-schedule-diagnostics`} startIcon={<FactCheckOutlinedIcon />}>Диагностика расписания и нагрузки преподавателя</Button></li>
                                </ol>
                            </Stack>
                        </CardContent>
                    </Card>
                    
                    <br />
                </Stack>
            </Container>
        </GeneralLayout>
    );
}
